import React from 'react';
import classNames from 'classnames';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { AuthBoxContainer } from './AuthList.css';

const SuperAuthBox = ({ auths, selectAuth, setSelectAuth }) => {
  const handleClick = (auth) => {
    setSelectAuth(auth);
  };

  return (
    <AuthBoxContainer>
      <div className="title">슈퍼관리자</div>
      <div className="content-box">
        {auths.map((auth) => {
          if (auth.memo.length > 18) {
            return (
              <OverlayTrigger key={'bottom'} placement={'bottom'} overlay={<Tooltip id={`tooltip`}>{auth.memo}</Tooltip>}>
                <div
                  className={classNames('content', selectAuth && selectAuth.authIdx === auth.authIdx && 'on')}
                  onClick={() => {
                    handleClick(auth);
                  }}
                >
                  ● {auth.authNm} - {auth.memo}
                </div>
              </OverlayTrigger>
            );
          }

          return (
            <div
              className={classNames('content', selectAuth && selectAuth.authIdx === auth.authIdx && 'on')}
              onClick={() => {
                handleClick(auth);
              }}
            >
              ● {auth.authNm} - {auth.memo}
            </div>
          );
        })}
      </div>
    </AuthBoxContainer>
  );
};

export default SuperAuthBox;
